<template>
  <base-edit :fields="fields" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs">
    <template slot="images" slot-scope="{ input }">
      <ImageList
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
              :required="true"
      />
    </template>
    <template slot="materials" slot-scope="{ input }">
      <Materials
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
              :required="true"
      />
    </template>
    <template slot="procedure" slot-scope="{ input }">
      <TextList
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
              :required="true"
              name="調理手順"
              width="600px"
              :limit="10"
              placeholder="玉ねぎはみじん切りにする。ボールにホールトマト缶詰を缶汁ごと入れ、手でかたまりをざっとつぶす。フライパンにオリーブオイル大さじ2を中火で熱し、玉ねぎを入れて、透き通ってしんなりとするまで炒める。"
      />
    </template>
    <template slot="keywords" slot-scope="{ input }">
      <Keyword
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
      />
    </template>
    <template slot="category" slot-scope="{ input }">
      <SelectList
              :input.sync="input"
              :resourceName="resourceName"
              name="レシピカテゴリ"
              width="600px"
              :limit="10"
              optionType="common/recipe_categories"
      />
    </template>
  </base-edit>
</template>

<script>
  import TextList from '../../components/field/text-list';
  import ImageList from '../../components/field/images-list';
  import Keyword from '../../components/field/keyword-list';
  import Materials from "../../components/field/materials";
  import SelectList from '../../components/field/select-list';

export default {
  components: {
    Materials,
    TextList,
    ImageList,
    Keyword,
    SelectList
  },
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      resourceName: "recipes",
      fields: [
        {
          label: "提供メーカー",
          name: "maker_id",
          type: 'select',
          rules: "required",
          optionType: "common/makers",
          width: "60%"
        },
        {
          label: "レシピID",
          name: "internal_recipe_id",
          rules: "max:255",
          width: "60%"
        },
        {
          label: "レシピ名",
          name: "dish_name",
          rules: "required|max:255",
          placeholder: "本場の絶品ラザニア",
          width: "60%"
        },
        {
          label: "レシピ名(かな)",
          name: "dish_name_kana",
          rules: "max:255|kana",
          width: "60%"
        },
        {
          label: "一言説明",
          type: "textarea",
          name: "description",
          rules: "required",
          placeholder: "イタリア料理の人気のメニュー。手の込んだメニューを簡易的に再現が可能です！",
          width: "100%"
        },
        {
          label: "レシピ画像",
          name: "images",
          type: "custom",
          rules: "required"
        },
        {
          label: "調理時間",
          name: "cooking_time",
          rules: 'required|numeric',
          unit: "分",
          placeholder: "40",
          width: "30%",
        },
        {
          label: "カロリー",
          name: "calorie",
          rules: 'numeric',
          type: 'currency',
          unit: "カロリー",
          placeholder: "414",
          width: "30%"
        },
        {
          label: "原価",
          name: "cost",
          rules: 'numeric',
          type: 'currency',
          unit: "円",
          placeholder: "500",
          width: "30%",
        },
        {
          label: "コツ／ポイント",
          name: "tips",
          type: "textarea",
          rules: 'required',
          placeholder: "ラザニア用パスタはソースの水分を吸収して柔らかくなりますので、ソースに重ねてオーブンで焼くだけ、茹でずに使用可能です。",
          width: "100%"
        },
        {
          label: "紐付き商品",
          name: "product_ids",
          type: "condiments",
          optionType: "common/products",
          textKey: "label",
          valueKey: "value",
          rules: 'required'
        },
        {
          label: "材料",
          name: "materials",
          type: "custom",
          rules: 'required'
        },
        {
          label: "調理手順",
          name: "procedure",
          rules: 'required',
          type: "custom",
          width: "100%"
        },
        // 自由入力のキーワード
        {
          label: "キーワード",
          name: "keywords",
          type: "custom"
        },
        {
          label: "レシピカテゴリ",
          name: "category",
          type: "custom"
        },
        {
          label: "公開",
          name: "published",
          type: "checkbox",
          textKey: "label",
          valueKey: "value",
          selects: [
            {
              label: "公開",
              value: 1
            }

          ]
        },
        {
          label: "会員限定フラグ",
          name: "user_plan_only",
          type: "checkbox",
          textKey: "label",
          valueKey: "value",
          selects: [
            {
              label: "会員限定",
              value: 1
            }

          ]
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "レシピ一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "レシピ編集",
          disabled: true
        }
      ];
    }
  }
};
</script>
